import {connect} from 'react-redux';
import ScheduledJobs from './ScheduledJobs';
import {index} from 'src/views/admin/utils/request';
import {ScheduledJob} from 'src/views/admin/ScheduledJobs/types';

const fetchScheduledJobTypes = (): Promise<ScheduledJob[]> =>
  // @ts-expect-error
  index('/v1/lists/scheduled-job-types');

export default connect(null, {
  fetchScheduledJobTypes,
})(ScheduledJobs);
